module.exports = lvflanders.bar.ng.ui;